import { createTheme } from "@mui/material";
import type {} from '@mui/x-data-grid/themeAugmentation';
import type {} from '@mui/x-data-grid-pro/themeAugmentation';

declare module '@mui/material/Toolbar' {
    interface ToolbarPropsVariantOverrides {
        primary: true;
    }
}

// Grace specific primary / secondary colours
export const theme = createTheme({
    typography: {
        fontFamily: '"gadugi", "Roboto", "Helvetica", "Arial", sans-serif',
    },
    palette: {
        primary: {
            main: '#344048',
        },
        secondary: {
            main: '#db291d',
        },
        background: {
            default: '#ffffff',
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none'
                }
            }
        },
        MuiGrid: {
            styleOverrides: {
                root: {
                    "& .MuiFormControl-root": {
                        marginLeft: '0',
                        marginRight: '0'
                    }
                }
            }
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    "& .MuiInputLabel-standard": {
                        left: "5px",
                        top: "-5px",
                        textIndent: "15px",
                    }, 
                    "& .MuiInputLabel-standard + .MuiInputBase-root:before": {
                        borderRadius: "8px", 
                    },
                    "& .MuiInputLabel-standard + .MuiInputBase-root:after": {
                        borderBottom: 0,
                    },
                    "& .MuiInputLabel-standard.MuiInputLabel-shrink": {
                        top: "0",
                    },
                    "& .MuiInputLabel-standard + .MuiInputBase-root .MuiInputBase-input": {
                        textIndent: "15px",
                    },
                    "& .MuiInputLabel-outlined" : {
                        left: "5px",
                        transform: "translate(14px, 20px) scale(1)",
                    },
                    "& .MuiInputLabel-outlined.MuiInputLabel-shrink" : {
                        transform: "translate(10px, -1.5px) scale(0.75)",
                    },
                    "& .MuiOutlinedInput-root fieldset": {
                        border: 0,
                    },
                    "& .MuiOutlinedInput-root": {
                        marginTop: '10px'
                    },
                    "& .MuiInput-underline:before": {
                        borderBottom: "0",
                    },
                    
                }
            }
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    background: "#f5f5f5",
                    borderRadius: "8px", 
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    color: "#ffffff",
                    opacity: 0.7,
                    "&.Mui-selected": {
                        color: "#ffffff",
                        opacity: 1,
                    }
                },
            }
        },
        MuiList: { 
            styleOverrides: {
                root: {
                    "& .MuiButtonBase-root": {
                        borderBottom: 'solid 1px gray',
                    }, 
                }
            }
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    border: '0',
                    "& .MuiDataGrid-toolbarContainer": {
                        marginLeft: '15px'
                    }
                },
            }
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    fontSize: '12rem',
                },
            }
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    backgroundColor: '#eaebec',
                    color: '#344048',
                    "& .MuiButtonBase-root": {
                        color: '#344048',
                    },
                    "& .MuiButtonBase-root.Mui-selected": {
                        color: '#344048',
                    },
                },
            }
        },
        MuiToolbar: {
            variants: [
                {
                    props: { variant: 'primary' },
                    style: {
                        backgroundColor: '#db291d',
                        color: '#FFF', 
                    },
                },
            ],
            styleOverrides: {
                root: {
                    backgroundColor: '#eaebec',
                    color: '#344048',
                    minHeight: '48px',
                }
            }
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    "& .MuiButtonBase-root": {
                        backgroundColor: '#344048',
                        borderRadius: '9999px',
                        color: '#FFF',
                        padding: '6px 15px'
                    }, 
                    "& .MuiButtonBase-root:hover": {
                        backgroundColor: '#242c32', 
                    }, 
                    "& .MuiButtonBase-root:last-child": {
                        backgroundColor: '#db291d',
                        borderRadius: '9999px',
                        color: '#FFF',
                        padding: '6px 15px'
                    },
                    "& .MuiButtonBase-root:last-child:hover": {
                        backgroundColor: '#991c14',
                    },
                }
            }
        }
    }
});
